export default {
    ALL_USER_TABLE_SCROLL_INTERVAL: 100,
    BULK_EMAIL_TABLE_ID: "outboxBulkEmailTable",
    CELL_TOOLTIP_DELAY: 300, // ms of delay time when hovering over a cell that has lots of text
    COLUMN_MAX_WIDTH: 5000,
    COLUMN_MIN_WIDTH: 25,
    MANTINE_COLUMN_MIN_WIDTH: 72,
    // The filter is two inputs side by side and need extra room to not overflow
    MANTINE_DATE_COLUMN_MIN_WIDTH: 164,
    COLUMN_NAME_OFFSET_PIXELS: 12,
    DATE_FORMAT: "MM/DD/YYYY",
    DATE_TIME_FORMAT: "MM/DD/YYYY h:mma",
    INDEX_COLUMN: -2,
    REMOVE_ROW_COLUMN_INDEX: "q-remove-row-index",
    DATUM_COLUMN_INDEX: -1,
    CREATOR_DATUM_COLUMN_INDEX: 4,
    DATUM_COLUMN_WIDTH: 300,
    DEFAULT_COLUMN_TYPE: DjangIO.app.userdata.spreadsheet.types.SheetColumnType.field.value,
    DEFAULT_COLUMN_WIDTH: 200,
    DEFAULT_SWAL_CONFIG: {
        icon: "warning",
        title: "Delete Row?",
        text: "You can also edit the set of rows directly in the sheet settings page.",
        buttons: ["Cancel", "Delete"],
    },
    DESCRIPTION_TEXT_AREA_HEIGHT: 300,
    DISABLED_TEXT: "Visualizations aren't currently supported for sheets with more than 2,500 rows.",
    ENABLED_TEXT: "Turn the numeric columns in this sheet into graphical visualizations.",
    SHEET_EXTERNAL_REGION_TOOLTIP:
        "Select the region that you would like the data on the external sheet to be applied to. Your internal region selector will not impact the region of the external sheet view.",
    FALSEY_VALUES: [undefined, null, ""],
    IFRAME_STYLE: `style="border-radius:4px;border:1px solid #303d60; width:100%; min-height: 800px;`,
    INDEX_COLUMN_WIDTH: 60,
    RESOURCE_TABLE_INDEX_COLUMN_WIDTH: 20,
    MAP_HEIGHT: 390,
    MAP_WIDTH: 959,
    MAX_COLUMNS_AT_ONCE: 100,
    MAX_COLUMNS_IN_SHEET: 200,
    MAX_SMALL_SHEET_SIZE: 2500,
    OUTBOX_SWAL_CONFIG: {
        icon: "warning",
        title: "Delete Draft?",
        text: "This will permanently delete this draft message",
        buttons: ["Cancel", "Delete Draft"],
    },
    TEMPLATE_SWAL_CONFIG: {
        icon: "warning",
        title: "Delete Template?",
        text: "This will permanently delete the Template",
        buttons: ["Cancel", "Delete Template"],
    },
    OUTBOX_TABLE_IDS: ["outboxBulkEmailTable", "outboxSendEmailResourceTable"],
    OUTBOX_TABLE_SCROLL_INTERVAL: 50,
    OUTBOUND_TEXTING_TABLE_SCROLL_INTERVAL: 50,
    REDUX_DEBOUNCE_TIME: 200, // time in ms to debounce redux actions, currently unused
    REQUEST_DEBOUNCE_TIME: 350, // time in ms to debounce network requests
    ROW_HEIGHT: 56,
    RESOURCE_TABLE_ROW_HEIGHT: 50,
    MAX_ROW_HEIGHT_FACTOR: 7,
    SEND_EMAIL_TABLE_ID: "outboxSendEmailResourceTable",
    CELL_HAS_ERROR_COLOR: "#ff0a006b",
    CELL_IS_EDITABLE_COLOR: "#a9bde499",
    TABLE_HEADER_HEIGHT: 56,
    RESOURCE_TABLE_TABLE_HEADER_HEIGHT: 50,
    TABLE_HEIGHT: 600,
    TABLE_SCROLL_INTERVAL: 1000,
    TABLE_FEW_ROWS_SCROLL_THRESHOLD: 0.2, // currently using this threshold for under 50 rows
    TABLE_SCROLL_THRESHOLD: 0.55,
    TABLE_WIDTH: 1500,
    TOOLTIP_SHOW_FUDGE_FACTOR: 1.5, // multiplier that helps determine if we should render a Tooltip,
    RESOURCE_TABLE_DATUM_COLUMN_WIDTH: 320,
    PRIORITY_STRING: " Priority",
    CIRCLE_COUNTER_MIN_OPACITY: 0.5,
    FONT_SIZE: "16px",
    FONT_WEIGHT: 400,
    YEAR_SELECT_NUMBER_OF_YEARS: 7,

    CUSTOM_COLOR_CONDITION_TYPE: {
        DATE: "DATE_COMPARISON_CONDITION",
        EXACT: "EXACT_MATCH_CONDITION",
        NUMERIC: "NUMERIC_COMPARISON_CONDITION",
    },
    ACTION_COLUMN_GRID_FORMAT: {
        COMPRESSED: "COMPRESSED",
        DEFAULT: "DEFAULT",
    },
    VALID_EMAIL_ALL_BUTTON_SHEET_DATA_TYPES: [
        DjangIO.app.models.QuorumDataType.staffer.value,
        DjangIO.app.models.QuorumDataType.person.value,
        DjangIO.app.models.QuorumDataType.supporter.value,
    ],
}
